<template>
  <div :class="$style.wrapper">
    <b-row>
      <b-col>
        <span :class="$style.title">
          {{ $t('quests.inviteUsers.INVITE-X-FRIENDS-TO-PLAY-ON-PICK8', { x: maxProgress }) }}
        </span>
      </b-col>
      <b-col
        cols="auto"
        class="text-right"
      >
        <span
          v-if="!isCompleted"
          :class="$style.title"
        >
          {{ progress }}/{{ maxProgress }}
        </span>
        <span
          v-else
          :class="[
            $style.title,
            $style.completed
          ]"
        >
          {{ $t('completed') }}
        </span>
      </b-col>
      <b-col
        :cols="12"
        class="pt-2"
      >
        <b-progress
          :max="maxProgress"
          striped
          animated
          variant="orange"
        >
          <b-progress-bar
            :value="progress"
          />
        </b-progress>
      </b-col>
      <b-col
        v-if="isCompleted && isClaimButtonShown"
        class="d-flex justify-content-center pt-2"
      >
        <BaseButton
          size="sm"
          font-size="small"
          is-rounded
        >
          <span class="px-4">
            {{ $t('quests.inviteUsers.claim-button') }}
          </span>
        </BaseButton>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import BaseButton from '@/components/Atoms/BaseButton'

export default {
  name: 'InviteUsersQuestProgress',
  components: { BaseButton },
  props: {
    isClaimButtonShown: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      totalProgress: 100,
    }
  },
  computed: {
    ...mapState({
      progress: state => state['quests/inviteUsersQuest'].progress,
      maxProgress: state => state['quests/inviteUsersQuest'].maxProgress,
    }),
    ...mapGetters({
      isCompleted: 'quests/inviteUsersQuest/isCompleted',
    }),
  },
}
</script>

<style scoped lang="scss">
  @import "../../../../assets/scss/variables";
  .bg-orange {
    background-color: $color-tomato;
  }
</style>

<style module lang="scss">
  @import "../../../../assets/scss/variables";
  .wrapper {
    border: 1px solid $color-tomato;
    padding: .5rem;
    border-radius: 2px;
    .title {
      font-weight: 600;
    }
    .completed {
      color: $color-tomato;
    }
  }
</style>
